import React, { useState } from 'react';
import api from '../api/expoApi';
import OtpModal from '../components/OtpModal';

const SCAN_TYPES = [
    { code: 'PICKUP',    label: 'Pickup' },
    { code: 'HUB_IN',    label: 'Inward to Hub' },
    { code: 'HUB_OUT',   label: 'Outward from Hub' },
    { code: 'RIDER_OUT', label: 'Out for Delivery (Rider)' },
    { code: 'DELIVERED', label: 'Delivered' },
    { code: 'FAILED',    label: 'Delivery Failed' }
];

export default function ScanCapture() {
    const [scanType, setScanType] = useState('HUB_IN');
    const [rawPayload, setRawPayload] = useState('');
    const [codAmount, setCodAmount] = useState('');
    const [notes, setNotes] = useState('');
    const [recent, setRecent] = useState([]);
    const [otpRequired, setOtpRequired] = useState(false);
    const [otpPhone, setOtpPhone] = useState('');
    const [msg, setMsg] = useState('');

    const submit = async () => {
        if (!rawPayload) { setMsg('Enter or scan a tracking ID / QR code'); return; }
        try {
            const body = { raw_payload: rawPayload, scan_type: scanType, notes };
            if (scanType === 'DELIVERED' && codAmount) body.cod_collected_amount = Number(codAmount);
            const r = await api.post('/scans', body);
            setMsg(`✓ Scanned ${r.data?.data?.tracking_id} as ${scanType}`);
            setRecent([{ ...r.data?.data, time: new Date().toLocaleTimeString() }, ...recent.slice(0, 9)]);
            setRawPayload('');
            setCodAmount('');
            setNotes('');
        } catch (e) {
            setMsg(`✗ ${e.response?.data?.message || 'Scan failed'}`);
        }
    };

    return (
        <div style={{ padding: 24, maxWidth: 600, margin: '0 auto' }}>
            <h1>Scan Capture</h1>

            <div style={{ background: '#fff', padding: 16, borderRadius: 8, marginBottom: 16, border: '1px solid #ddd' }}>
                <label style={{ display: 'block', marginBottom: 4, fontWeight: 600 }}>Scan Type</label>
                <select value={scanType} onChange={(e) => setScanType(e.target.value)} style={{ width: '100%', padding: 10, fontSize: '1rem' }}>
                    {SCAN_TYPES.map((t) => <option key={t.code} value={t.code}>{t.label}</option>)}
                </select>

                <label style={{ display: 'block', marginTop: 12, marginBottom: 4, fontWeight: 600 }}>Tracking ID or QR Payload</label>
                <input
                    autoFocus
                    placeholder="ECL2025010100001 or paste QR JSON"
                    value={rawPayload}
                    onChange={(e) => setRawPayload(e.target.value)}
                    onKeyDown={(e) => { if (e.key === 'Enter') submit(); }}
                    style={{ width: '100%', padding: 10, fontSize: '1.1rem', fontFamily: 'monospace' }}
                />

                {scanType === 'DELIVERED' && (
                    <>
                        <label style={{ display: 'block', marginTop: 12, marginBottom: 4, fontWeight: 600 }}>COD Amount Collected (PKR)</label>
                        <input
                            type="number" step="0.01" placeholder="0.00 if no COD"
                            value={codAmount} onChange={(e) => setCodAmount(e.target.value)}
                            style={{ width: '100%', padding: 10, fontSize: '1rem' }}
                        />
                    </>
                )}

                <label style={{ display: 'block', marginTop: 12, marginBottom: 4, fontWeight: 600 }}>Notes (optional)</label>
                <input value={notes} onChange={(e) => setNotes(e.target.value)} style={{ width: '100%', padding: 10 }} />

                <button onClick={submit} style={{
                    width: '100%', padding: 14, marginTop: 16, fontSize: '1.1rem',
                    background: '#0d6efd', color: '#fff', border: 'none', borderRadius: 6, fontWeight: 600
                }}>
                    Submit Scan
                </button>
            </div>

            {msg && (
                <div style={{
                    padding: 12, borderRadius: 4,
                    background: msg.startsWith('✓') ? '#d1e7dd' : '#f8d7da',
                    color: msg.startsWith('✓') ? '#0a3622' : '#842029',
                    marginBottom: 12
                }}>{msg}</div>
            )}

            {recent.length > 0 && (
                <>
                    <h3>Recent Scans</h3>
                    <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff' }}>
                        <thead><tr><th>Time</th><th>Tracking ID</th></tr></thead>
                        <tbody>
                            {recent.map((r, i) => (
                                <tr key={i}>
                                    <td>{r.time}</td>
                                    <td><code>{r.tracking_id}</code></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
            )}

            {otpRequired && (
                <OtpModal
                    phone={otpPhone}
                    purpose="DELIVERY"
                    onVerified={() => { setOtpRequired(false); submit(); }}
                    onCancel={() => setOtpRequired(false)}
                />
            )}
        </div>
    );
}
